import React from "react";
import FieldErrorComponent from "../FieldErrorComponent";
import LabelComponent from "../LabelComponent";
import ExtraInfo from "../ExtraInfo/index";
import Tooltip from "../../Tooltip/index";
import AttentionIcon from "../../../../Theming/icons/AttentionIcon";
import "./index.css";
const EmailInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const isGeneric = typeof props.isGeneric === "undefined" ? true : props.isGeneric;
  const hasTooltip = props.tooltipTitle || props.tooltipDescription;
  const hasErrors = props.errors && (props.errors.type || props.errors.length > 0);
  const events = {
    onChange: e => {
      if (props.events && props.events.onChange) {
        props.events.onChange(e);
      }
      if (props.setEmail) {
        props.setEmail(e.target.value);
      }
    },
    onFocus: e => {
      if (props.events && props.events.onFocus) {
        props.events.onFocus(e);
      }
    },
    onBlur: e => {
      if (props.events && props.events.onBlur) {
        props.events.onBlur(e);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `form__field form__field--email ${hasErrors ? "form__field--error" : ""} ${hasErrors && props.classNameError ? props.classNameError : ""} ${!isGeneric ? "form__field--small" : ""} ${hasTooltip ? "form__field--tooltip" : ""} ${props.labelClassName ? props.labelClassName : ""} ${props.readOnly ? "form__field--read-only" : ""}`
  }, /*#__PURE__*/React.createElement(LabelComponent, props), hasTooltip && /*#__PURE__*/React.createElement(Tooltip, {
    title: props.tooltipTitle,
    description: props.tooltipDescription
  }), /*#__PURE__*/React.createElement(ExtraInfo, {
    text: props.extraInfo
  }), /*#__PURE__*/React.createElement("div", {
    className: "form__input-wrapper form__field-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    readOnly: props.readOnly,
    autoFocus: props.autoFocus,
    className: props.className,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    onChange: events.onChange,
    onFocus: events.onFocus,
    onBlur: events.onBlur,
    id: props.id,
    name: props.fieldName,
    defaultValue: props.defaultValue,
    ref: ref,
    autoComplete: "email",
    "aria-required": props.isRequired,
    "aria-describedby": props.describedBy
  }), hasErrors && /*#__PURE__*/React.createElement(AttentionIcon, {
    className: "form__attention-icon"
  })), hasErrors && /*#__PURE__*/React.createElement(FieldErrorComponent, props));
});
export default EmailInput;